import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface DialogState {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const useDialogStore = create<DialogState>()(
  devtools((set) => ({
    isLoading: false,
    setIsLoading: (isLoading) => set({ isLoading }),
  }))
);
